import { PersonalAtendimentosListSearchComponent } from './PersonalAtendimentosListSearchComponent'
import { PersonalAtendimentosListToolbar } from './PersonalAtendimentosListToolbar'

export const PersonalAtendimentosListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <PersonalAtendimentosListSearchComponent actions={<PersonalAtendimentosListToolbar />} />
  </div>
)
